<template>
    <div class="row">
        <b-card class="col-12" no-body>
            <b-form @submit="onSubmit" class="row">
                <input-text class="col-12" label="Especificações" disabled v-model="documento.especificacao"/>
                <input-textarea class="col-12" label="Descrição" disabled v-model="documento.descricao"/>
                <input-textarea class="col-12" label="Detalhamento" disabled v-model="documento.detalhamento"/>
                <div class="col-12 mb-2">
                    <upload  tituloArquivo="Arrastar Arquivo" 
                        @upload="(file, nomeArquivo)=> {
                            let arquivo = {
                                nome: nomeArquivo,
                                arquivo: file
                            }
                            
                            form.arquivo = arquivo
                        }" selecioneArquivo="Selecionar Arquivo" type=".*" />
                </div>
                <div class="col-12 d-flex">
                    <b-button variant="success" type="submit" v-if="form.id && permissao.u">
                        <i class="fa-solid fa-check mr-2"></i>
                        Salvar
                    </b-button>
                </div> 
            </b-form>
        </b-card>
    </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import InputTextarea from "@/components/inputs/InputTextarea";
import Upload from "@/components/upload/Upload";

import DocumentosService from "@/common/services/documentos/documentos.service";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import Swal from "sweetalert2";

export default {
    name: "DocumentosList",
    props: ['id'],
    components: {
        InputText,
        InputTextarea,
        Upload
    },
    data: () => ({
        documento: {
            especificacao: "",
            descricao: "",
            detalhamento: "",
        },
        form:{
            id: null,
            arquivo: null,
        }
    }),
    methods: {
        fetchDocumento: function(id){
            this.$store.dispatch(START_LOADING);
            DocumentosService.listar(this.selectedCompany.id).then(response => {
                let doc = response.data.data.itens.find(item => item.id == id);
                this.documento.especificacao = doc.especificacao;
                this.documento.descricao = doc.descricao;
                this.documento.detalhamento = doc.detalhamento;

                this.form.id = doc.id;
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        onSubmit: function(e){
            e.preventDefault();
            if(!this.permissao.u)
                return;

            Swal.fire({
                title: "Aviso",
                text: "Deseja atualizar o arquivo do documento?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: 'Sim',
                denyButtonText: `Não`
            }).then((result) =>{
                if (result.isConfirmed) {

                    if(!this.form.arquivo){
                        Swal.fire({
                            title: "Aviso",
                            text: "Selecione um arquivo para atualizar",
                            icon: "warning",
                            confirmButtonText: 'Ok'
                        });
                        return;
                    }

                    this.$store.dispatch(START_LOADING);

                    let form = {
                        id: this.form.id,
                        arquivoBase64: this.form.arquivo.arquivo,
                        nomeArquivoAWS: this.form.arquivo.nome,
                    }

                    DocumentosService.store(form).then(() => {
    
                        Swal.fire({
                            title: "Sucesso",
                            text: "Arquivo atualizado com sucesso!",
                            icon: "success",
                        }).then(() =>{
                            this.$router.push({ name: "documentos" });
                        });
                        
                    }).catch(() => {

                        Swal.fire({
                            title: "Erro",
                            text: "Ocorreu um erro ao atualizar arquivo!",
                            icon: "error",
                            confirmButtonText: "Ok"
                        });

                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });

                } 
            });
        }
    },
    mounted(){
        if(!this.id)
            this.$router.push({name: "documentos"});

        this.fetchDocumento(this.id);

        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            {titulo : "Modelos de documentos", to: {name: "documentos"}},
            { titulo: "Editar" }
        ]);
    },
    computed: {
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ModelosDocumentos');
        }, 
                
        selectedCompany() {
            return this.$store.state.app.selectedCompanyObj;
        },
    }    
}
</script>
<style>
   .card {
        min-height: inherit !important;
    }
</style>